export const toString = (value?: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return `${value}`;
  if (typeof value === 'object') return '';

  return `${value}`;
};

export const toStringOrNull = (value?: unknown): string | null => {
  if (value === null || value === undefined || value === '') return null;

  const result = toString(value);

  return result === '' ? null : result;
};

export const toNumber = (value?: unknown): number => {
  if (typeof value === 'number') return Number.isNaN(value) ? 0 : value;
  if (typeof value === 'boolean') return value ? 1 : 0;
  if (typeof value !== 'string') return 0;

  const result = Number(value.trim());

  return Number.isNaN(result) ? 0 : result;
};

export const toBoolean = (value?: unknown): boolean => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value !== 'string') return !!value;

  const normalised = value.trim().toLowerCase();

  return !['', '0', 'false', 'null', 'undefined', 'no'].includes(normalised);
};

export const toId = (value?: unknown): string => toString(value);
